import {createContext} from 'react';
import PaFormFields from "../../shared/PaFormFields";
import PaFormSteps from '../../shared/PaFormSteps';
import {apiStatus} from '../../shared/enums';
import defaultValues from './default-context';

const fields = {};
const fieldsDefault = {errors: [], isDirty: false, isValid: false, value: '', options: [], hasValue: null};
// get the fields from the field config
Object.keys(PaFormFields).forEach(key => {
    fields[key] = {...fieldsDefault};
    if (defaultValues[key]){
        fields[key].value = defaultValues[key];
        fields[key].hasValue = false;
    }
});

const stepDefaults = {hasNext: true, completed: false, isValid: false};
const steps = PaFormSteps.map((step, i) => ({...stepDefaults, isActive: i === 0}))

// create the default values for context from the form fields
export const PriorAuthorizationDefault = {
    // common properties used in inquiry and create workflows
    authNumber: "",
    priorAuthStatusFromView: null,
    fields,
    operation: 'create',
    // props meant to be used for Banner component
    bannerProps: {
        message: '',
        severity: '',
        onClick: null,
        open: true
    },
    modalState: {
        isBlocking: true,
        confirm: null,
        confirmText: null,
        confirmToolTip: null,
        deny: null,
        denyText: null,
        denyToolTip: null,
        open: false,
        title: null
    },
    status: apiStatus.DEFAULT,
    cb: null,

    // properties used in create flow only
    create: {
        currentStep: 0,
        steps
    },
    // properties used in inquiry flow only
    inquiry: {
        data: "",
        error: "",
        rootOperation: "",
        view: "results",
        requestId: null,
        advancedSearch: false,
        resendVerbiage: ''
    }
};

const PriorAuthorizationContext = createContext(PriorAuthorizationDefault);
export default PriorAuthorizationContext;